import {
  Box,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Input,
  Select,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";
import background from "../../assets/bg.jpg";
import Menubar from "../../components/Menubar";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  editKenshi,
  getAllKenshi,
  registerKenshi,
} from "../../store/actionCreators/kenshiAction";
import { getAllDojo } from "../../store/actionCreators/dojoAction";
// import { baseUrl } from "../../apis/baseUrl";
import { ACCENT_1_COLOR } from "../../constants/color";

export default function KenshiList() {
  const dispatch = useDispatch();
  const { kenshi } = useSelector((store) => store.rootReducer.kenshiReducer);
  const [newKenshiForm, setNewKenshiForm] = useState({});
  const [editKenshiId, setEditKenshiId] = useState(0);
  const [editKenshiForm, setEditKenshiForm] = useState({});

  const { dojo } = useSelector((store) => store.rootReducer.dojoReducer);

  const {
    isOpen: isOpenNew,
    onOpen: onOpenNew,
    onClose: onCloseNew,
  } = useDisclosure();

  const {
    isOpen: isOpenEdit,
    onOpen: onOpenEdit,
    onClose: onCloseEdit,
  } = useDisclosure();

  useEffect(() => {
    dispatch(getAllKenshi());
    dispatch(getAllDojo());
  }, [dispatch]);

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setNewKenshiForm({ ...newKenshiForm, [name]: value });
  };

  const handleOpenEdit = (kenshi) => {
    let tempEditForm = {
    };
    if (kenshi.nik) tempEditForm.nik = kenshi.nik;
    if (kenshi.email) tempEditForm.email = kenshi.email;
    if (kenshi.name) tempEditForm.name = kenshi.name;
    if (kenshi.birthday) tempEditForm.birthday = kenshi.birthday;
    if (kenshi.level) tempEditForm.level = kenshi.level;
    if (kenshi.role) tempEditForm.role = kenshi.role;
    if (kenshi.position) tempEditForm.position = kenshi.position;
    if (kenshi.status) tempEditForm.status = kenshi.status;
    if (kenshi.dojo) tempEditForm.dojo = kenshi.dojo;
    setEditKenshiId(kenshi.id)
    setEditKenshiForm(tempEditForm);
    onOpenEdit();
  };

  const handleCloseNew = () => {
    setNewKenshiForm({});
    onCloseNew();
  };

  const handleCloseEdit = () => {
    setEditKenshiForm({});
    onCloseEdit();
  };

  const handleChangeEditForm = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setEditKenshiForm({ ...editKenshiForm, [name]: value });
  };

  const registerNewKenshi = async () => {
    try {
      if (!(!newKenshiForm.email || !newKenshiForm.password || !newKenshiForm.name || !newKenshiForm.birthday || !newKenshiForm.level || !newKenshiForm.status || !newKenshiForm.dojo || !newKenshiForm.position || !newKenshiForm.role)) {
        dispatch(registerKenshi(newKenshiForm));
        handleCloseNew();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateKenshi = async () => {
    try {
      if (!(!editKenshiForm.email || !editKenshiForm.name || !editKenshiForm.birthday || !editKenshiForm.level || !editKenshiForm.status || !editKenshiForm.dojo || !editKenshiForm.position || !editKenshiForm.role)) {
        dispatch(editKenshi(editKenshiId, editKenshiForm));
        handleCloseEdit();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box
      display={"flex"}
      minH={"100vh"}
      width={"100vw"}
      background={`transparent url(${background})`}
      bgRepeat={"repeat"}
      pb={"24px"}
    >
      <Box
        width={"100vw"}
      >
        <Menubar />
        <Box
          width={"100vw"}
          px={{ base: "5vw", lg: "20vw" }}
          height={"100px"}
          display={"flex"}
          flexDir={"column"}
          textAlign={"left"}
          mt={"18px"}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Text textColor={ACCENT_1_COLOR} fontSize={"30px"}>
              Mugai Ryu Indonesia
            </Text>
            <Box
              as="button"
              w={"200px"}
              py={"8px"}
              border={`1px solid ${ACCENT_1_COLOR}`}
              color={ACCENT_1_COLOR}
              className="cormorant-garamond-normal"
              fontSize={"15px"}
              letterSpacing={"2px"}
              transition={"all 0.3s ease"}
              _hover={{
                bg: ACCENT_1_COLOR,
                color: "#F7F5F0",
              }}
              onClick={() => onOpenNew()}
            >
              Register New Kenshi
            </Box>
          </Box>

          <Text
            textColor={"#765946"}
            fontStyle={"italic"}
            fontSize={"18px"}
            mb={"24px"}
          >
            Kenshi List
          </Text>

          <Table>
            <Thead>
              <Tr>
                <Th color={ACCENT_1_COLOR} textAlign={"center"}>NIK</Th>
                <Th color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                <Th color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                <Th color={ACCENT_1_COLOR} textAlign={"center"}>Dojo</Th>
                <Th color={ACCENT_1_COLOR} textAlign={"center"}>Active</Th>
              </Tr>
            </Thead>
            <Tbody>
              {kenshi.length > 0 &&
                kenshi.map((el) => (
                  <Tr>
                    <Td>{el.nik}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.level}</Td>
                    <Td>{el.Dojo.name}</Td>
                    <Td textAlign={"center"}>{el.status === 'active' ? 'Y' : 'N'}</Td>
                    <Td>
                      <Box
                        as="button"
                        w={"80px"}
                        py={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>
                ))}
            </Tbody>
          </Table>
        </Box>

        {/* REGISTER NEW KENSHI MODAL */}
        <Modal
          isOpen={isOpenNew}
          onClose={handleCloseNew}
          isCentered
          closeOnOverlayClick={false}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader color={ACCENT_1_COLOR}>Register new Kenshi</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box>
                <Text color={ACCENT_1_COLOR}>NIK</Text>
                <NumberInput
                  onChange={(e) =>
                    setNewKenshiForm({ ...newKenshiForm, nik: e })
                  }
                >
                  <NumberInputField placeholder="NIK" _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}/>
                </NumberInput>
              </Box>
              <Box>
                <Text color={ACCENT_1_COLOR}>Name</Text>
                <Input
                  placeholder="Kenshi name"
                  name="name"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>
              <Box>
                <Text color={ACCENT_1_COLOR}>Email</Text>
                <Input
                  placeholder="Kenshi email"
                  name="email"
                  onChange={(e) => handleChange(e)}
                  type="email"
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>

              <Box>
                <Text color={ACCENT_1_COLOR}>Password</Text>
                <Input
                  placeholder="Kenshi password"
                  name="password"
                  onChange={(e) => handleChange(e)}
                  type="password"
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>

              <Box>
                <Text color={ACCENT_1_COLOR}>Birthday</Text>
                <Input
                  placeholder="Kenshi password"
                  name="birthday"
                  onChange={(e) => handleChange(e)}
                  type="date"
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>

              <Box>
                <Text color={ACCENT_1_COLOR}>Level</Text>
                <Select
                  placeholder="Kenshi Level"
                  name="level"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="Candidate">Candidate</option>
                  <option value="Mukyu">Mukyu</option>
                  <option value="Gokyu">Gokyu</option>
                  <option value="Yonkyu">Yonkyu</option>
                  <option value="Sankyu">Sankyu</option>
                  <option value="Nikyu">Nikyu</option>
                  <option value="Ikkyu">Ikkyu</option>
                  <option value="Shodan">Shodan</option>
                  <option value="Nidan">Nidan</option>
                </Select>
              </Box>
              <Box>
                <Text color={ACCENT_1_COLOR}>Dojo</Text>
                <Select
                  placeholder="Kenshi Dojo"
                  name="dojo"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  {dojo.length > 0 &&
                    dojo.map((el) => <option value={el.id}>{el.name}</option>)}
                </Select>
              </Box>
              <Box>
                <Text color={ACCENT_1_COLOR}>Status</Text>
                <Select
                  placeholder="Kenshi Status"
                  name="status"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="active">Active</option>
                  <option value="not active">Not Active</option>
                  <option value="suspended">Suspended</option>
                  <option value="hamon">Hamon</option>
                </Select>
              </Box>

              <Box>
                <Text color={ACCENT_1_COLOR}>Position</Text>
                <Select
                  placeholder="Kenshi Position"
                  name="position"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="Kenshi">Kenshi</option>
                  <option value="Basocho">Basocho</option>
                  <option value="Shibucho">Shibucho</option>
                </Select>
              </Box>
              <Box>
                <Text color={ACCENT_1_COLOR}>Role</Text>
                <Select
                  placeholder="Kenshi Role"
                  name="role"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </Select>
              </Box>
            </ModalBody>

            <ModalFooter>
              <Box
                as="button"
                w={"100px"}
                py={"8px"}
                border={`1px solid ${ACCENT_1_COLOR}`}
                color={ACCENT_1_COLOR}
                className="cormorant-garamond-normal"
                fontSize={"15px"}
                letterSpacing={"2px"}
                transition={"all 0.3s ease"}
                _hover={!(!newKenshiForm.email || !newKenshiForm.password || !newKenshiForm.name || !newKenshiForm.birthday || !newKenshiForm.level || !newKenshiForm.status || !newKenshiForm.dojo || !newKenshiForm.position || !newKenshiForm.role) ? {
                  bg: ACCENT_1_COLOR,
                  color: "#F7F5F0",
                } : {cursor: "not-allowed", opacity: 0.6}}
                onClick={registerNewKenshi}
              >
                Register
              </Box>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* EDIT KENSHI PROFILE MODAL */}
        <Modal
          isOpen={isOpenEdit}
          onClose={handleCloseEdit}
          isCentered
          closeOnOverlayClick={false}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader color={ACCENT_1_COLOR}>Edit Kenshi Profile</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box>
                <Text color={ACCENT_1_COLOR}>NIK</Text>
                <NumberInput
                  onChange={(e) =>
                    setEditKenshiForm({ ...editKenshiForm, nik: e })
                  }
                  value={editKenshiForm.nik}
                >
                  <NumberInputField _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }} />
                </NumberInput>
              </Box>
              <Box>
                <Text color={ACCENT_1_COLOR}>Name</Text>
                <Input
                  placeholder="Kenshi name"
                  name="name"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editKenshiForm.name}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>

              <Box>
                <Text color={ACCENT_1_COLOR}>Email</Text>
                <Input
                  placeholder="Kenshi email"
                  name="email"
                  onChange={(e) => handleChangeEditForm(e)}
                  type="email"
                  value={editKenshiForm.email}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>

              <Box>
                <Text color={ACCENT_1_COLOR}>Birthday</Text>
                <Input
                  placeholder="Kenshi password"
                  name="birthday"
                  onChange={(e) => handleChangeEditForm(e)}
                  type="date"
                  value={editKenshiForm.birthday?.split("T")[0]}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>

              <Box>
                <Text color={ACCENT_1_COLOR}>Level</Text>
                <Select
                  placeholder="Kenshi Level"
                  name="level"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editKenshiForm.level}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="Candidate">Candidate</option>
                  <option value="Mukyu">Mukyu</option>
                  <option value="Gokyu">Gokyu</option>
                  <option value="Yonkyu">Yonkyu</option>
                  <option value="Sankyu">Sankyu</option>
                  <option value="Nikyu">Nikyu</option>
                  <option value="Ikkyu">Ikkyu</option>
                  <option value="Shodan">Shodan</option>
                  <option value="Nidan">Nidan</option>
                </Select>
              </Box>
              <Box>
                <Text color={ACCENT_1_COLOR}>Dojo</Text>
                <Select
                  placeholder="Kenshi Dojo"
                  name="dojo"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editKenshiForm.dojo}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  {dojo.length > 0 &&
                    dojo.map((el) => <option value={el.id}>{el.name}</option>)}
                </Select>
              </Box>
              <Box>
                <Text color={ACCENT_1_COLOR}>Status</Text>
                <Select
                  placeholder="Kenshi Status"
                  name="status"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editKenshiForm.status}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="active">Active</option>
                  <option value="not active">Not Active</option>
                  <option value="suspended">Suspended</option>
                  <option value="hamon">Hamon</option>
                </Select>
              </Box>

              <Box>
                <Text color={ACCENT_1_COLOR}>Position</Text>
                <Select
                  placeholder="Kenshi Position"
                  name="position"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editKenshiForm.position}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="Kenshi">Kenshi</option>
                  <option value="Basocho">Basocho</option>
                  <option value="Shibucho">Shibucho</option>
                </Select>
              </Box>
              <Box>
                <Text color={ACCENT_1_COLOR}>Role</Text>
                <Select
                  placeholder="Kenshi Role"
                  name="role"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editKenshiForm.role}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </Select>
              </Box>
            </ModalBody>

            <ModalFooter>
              <Box
                as="button"
                w={"80px"}
                py={"8px"}
                border={`1px solid ${ACCENT_1_COLOR}`}
                color={ACCENT_1_COLOR}
                className="cormorant-garamond-normal"
                fontSize={"15px"}
                letterSpacing={"2px"}
                transition={"all 0.3s ease"}
                _hover={!(!editKenshiForm.email || !editKenshiForm.name || !editKenshiForm.birthday || !editKenshiForm.level || !editKenshiForm.status || !editKenshiForm.dojo || !editKenshiForm.position || !editKenshiForm.role) ? {
                  bg: ACCENT_1_COLOR,
                  color: "#F7F5F0",
                } : {cursor: "not-allowed", opacity: 0.6}}
                onClick={handleUpdateKenshi}
              >
                Edit
              </Box>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </Box>
  );
}
